$(document).ready(function() {
  // Set first item as active
  $('.timeline-item').first().addClass('active');

  // Click on item
  $('.timeline-item').on('click', function() {
    $('.timeline-item').removeClass('active');
    $(this).addClass('active');
  });

  // Click on next arrow
  $('.timeline-next').on('click', function() {
    let $current = $('.timeline-item.active');
    let $next = $current.next('.timeline-item');
    if ($next.length) {
      $current.removeClass('active');
      $next.addClass('active');
    }
  });

  // Click on prev arrow
  $('.timeline-prev').on('click', function() {
    let $current = $('.timeline-item.active');
    let $prev = $current.prev('.timeline-item');
    if ($prev.length) {
      $current.removeClass('active');
      $prev.addClass('active');
    }
  });
});




$('.dekstech-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    arrows: false,
    swipe: false,
    slidesToShow: 5,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    variableWidth: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
  });
    $('.product-logo-slider').slick({
    autoplay: true,
    autoplaySpeed: 0,
    speed:6000,
    arrows: false,
    swipe: false,
    slidesToShow: 5,
    cssEase: 'linear',
    pauseOnFocus: false,
    pauseOnHover: false,
    variableWidth: true,
    infinite: true,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
  });
$('.rating-slider').slick({
  vertical: true,
  verticalSwiping: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  infinite: true
});

 $('.review-info-slider').slick({
   slidesToShow: 1,
   slidesToScroll: 1,
   arrows: false,
   fade: true,
   asNavFor: '.slider-nav',
   adaptiveHeight: true,
   infinite: false
 });
 $('.slider-nav').slick({
   infinite: false,
   slidesToShow: 4,
   slidesToScroll: 1,
   asNavFor: '.review-info-slider',
   dots: false,
   focusOnSelect: true
 });




  $(".blog-slider").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_814)"><path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 18L5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 6L5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_814"><rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/></clipPath></defs></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_821)"><path d="M5 12H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 18L19 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 6L19 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_821"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          slidesToShow: 1.3, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
    ],
  });

  $(".featured-collection .product-grid").slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_814)"><path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 18L5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 6L5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_814"><rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/></clipPath></defs></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_821)"><path d="M5 12H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 18L19 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 6L19 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_821"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></button>',
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          arrows: false,
        },
      },
      {
        breakpoint: 580,
        settings: {
          arrows: false,
          slidesToShow: 1.3, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
    ],
  });



  $(".testimonials-grid").slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<button class="slide-arrow prev-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_814)"><path d="M19 12H5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 18L5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M11 6L5 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_814"><rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"/></clipPath></defs></svg></button>',
    nextArrow: '<button class="slide-arrow next-arrow"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1_821)"><path d="M5 12H19" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 18L19 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M13 6L19 12" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g><defs><clipPath id="clip0_1_821"><rect width="24" height="24" fill="white"/></clipPath></defs></svg></button>',
    responsive: [
      {
        breakpoint: 1600,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
      {
        breakpoint: 580,
        settings: {
          slidesToShow: 2, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
        },
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow:1, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
          arrows: false,
          centerMode: true,
          centerPadding: '70px',
        },
      },
      {
        breakpoint: 374,
        settings: {
          slidesToShow:1, // Ensure only 1 slide is shown
          slidesToScroll: 1, // Ensure only 1 slide is scrolled
          arrows: false,
          centerMode: true,
          centerPadding: '30px',
        },
      },
    ],
  });
